import { route } from '../../helpers';
import { AccountPages } from '../../../constants/AppConstants';

export default route(AccountPages.SMARTCARD_LINK_CONFIRMATION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../../components/account/smartcard/link/ConfirmAssociation').default);
        }, 'account-smartcard-link-confirmation');
    }
});
